import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mobileNavDrawer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.agentTheme.card.main,
    height: "100vh",
    paddingTop: "30px",
  },
  closeBtn: {
    marginRight: "40px",
  },
  navContentContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "16px",
    paddingBottom: "16px",
    borderBottom: `0.5px solid ${theme.agentTheme.card.muted_foreground}`,
    width: "60%",
    [theme.breakpoints.up("sm")]: {
      width: "60%",
    },
  },
  loginButtonStyle: {
    height: "38px",
    margin: "1rem 0 0 1.2rem",
    minWidth: "135px",
    color: theme?.agentTheme?.secondary?.main,
    [theme.breakpoints.down("sm")]: {
      height: "38px",
      minWidth: "76px",
    },
  },
  navBarText: {
    justifyContent: "center",
    alignItems: "center",
    color: theme.agentTheme.card.link_foreground,
    fontSize: "14px",
    fontWeight: 700,
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
  },
  contentTextSideNavbar: {
    fontWeight: 700,
    fontSize: "14px",
    color: theme.agentTheme.card.link_foreground,
    marginRight: "50px",
    cursor: "pointer",
    marginTop: "16px",
    textDecoration: "none",
  },
  dropDownCard: {
    position: "absolute !important",
  },
  menuLogo: {
    height: "40.3px",
    width: "auto",
  },
  menuItemHeading: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
  },
  menuItemText: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginTop: "14px",
    marginBottom: "26px",
    lineHeight: "20px",
  },
  mobilHelpDrawer: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.agentTheme.card.link_foreground,
    height: "100vh",
    width: "100vw",
  },
  helpCloseBtn: {
    marginRight: "14px",
  },
  loginButton: {
    color: theme.agentTheme.primary.main,
    backgroundColor: "transparent",
    height: "38px",
    width: "135px",
    marginLeft: 20,
    [theme.breakpoints.down("sm")]: {
      height: "38px",
      width: "76px",
    },
  },
}));

export default useStyles;
